import * as React from 'react';
/**
 *
 * Original name: edit
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A533
 *
 */
export const EditSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M91.171 43.021a12.999 12.999 0 0 0 0-18.386l-1.857-1.856a13 13 0 0 0-18.385 0l-40.55 40.549-5.713 26.026 26.476-6.3 40.029-40.033Zm-16-16a7.002 7.002 0 0 1 9.9 0l1.858 1.856a7.01 7.01 0 0 1 0 9.9l-5.454 5.454-11.758-11.756 5.454-5.454Zm-36.158 52.75-5-5 1.852-8.439 29.61-29.615 11.758 11.758L48.1 77.607l-9.087 2.164ZM101 95H19v6h82v-6Z", fill: "currentColor" })));
